import { Component } from '@angular/core';

@Component({
  selector: 'app-page-404-not-found',
  styleUrls: ['./404.component.scss'],
  templateUrl: './404.component.html',
  standalone: false,
})
export class Page404Component {}
